import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import Swal from 'sweetalert2';

     let Listado = []
const CagarImagenesArticulos = ({ ArtID }) => {
     const [Guardar, setGuardar] = useState(true);
     const [VFile, setVFile] = useState();

    //alert(ArtID)
    const handleInputChange = async (e) => {
        console.log(e.target.files)
        const input = e.target ;
        const [file] = input.files;

        const data = new FormData();

        data.append('file', file);
        data.append('ArticuloID', ArtID[0]);

        const res = await fetch(Api+"SeguridadSaludMantenimiento/CargarImagenArticulo", {
            method: 'POST',
body:data
        })
    }

    
    return (
        <>
            <input

                required
                type="file"
                name="file"
                id="file"
                onChange={handleInputChange}
                placeholder="Archivo de Excel"
                value={VFile }
            />
            <Button hidden={Guardar} color="success" size="sm" className="mr-2"
               
            >
                <i className="fas fa-save">  Guardar</i>
            </Button>
           
            
          
        </>
    )
}
export default CagarImagenesArticulos;